import { MadeRightRoot, FoodOption, ButtonBox, FoodBox, Span, Header } from './MadeRight.styles'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'
import Trans from 'next-translate/Trans'
import { Button } from 'components/Button'
import Link from 'next/link'

type MadeRightProps = {
  type: 'frozen' | 'freeze-dried'
}

export const MadeRight = ({ type }: MadeRightProps) => {
  const { t } = useTranslation()

  return (
    <MadeRightRoot>
      <Stack direction="column" alignItems="center">
        <Header align="center" as="h3" size={{ '@initial': 'h4', '@bp2': 'h1' }}>
          <Trans
            components={{
              br: <br />,
            }}
            i18nKey="recipes-overview:made-right.title"
          />
        </Header>
        <FoodBox>
          <FoodOption>
            <Text font="label" size="h5" css={{ textTransform: 'uppercase' }}>
              {t(`recipes-overview:made-right.${type}.safety.title`)}
            </Text>
            <Text>
              <Trans
                components={{ Span: <Span /> }}
                i18nKey={`recipes-overview:made-right.${type}.safety.description`}
              />
            </Text>
          </FoodOption>
          <FoodOption>
            <Text font="label" size="h5" css={{ textTransform: 'uppercase' }}>
              {t(`recipes-overview:made-right.${type}.convenience.title`)}
            </Text>
            <Text>
              <Trans
                components={{ Span: <Span /> }}
                i18nKey={`recipes-overview:made-right.${type}.convenience.description`}
              />
            </Text>
          </FoodOption>
          <FoodOption>
            <Text font="label" size="h5" css={{ textTransform: 'uppercase' }}>
              {t(`recipes-overview:made-right.${type}.quality.title`)}
            </Text>
            <Text>
              <Trans
                components={{ Span: <Span /> }}
                i18nKey={`recipes-overview:made-right.${type}.quality.description`}
              />
            </Text>
          </FoodOption>
          <FoodOption>
            <Text font="label" size="h5" css={{ textTransform: 'uppercase' }}>
              {t(`recipes-overview:made-right.${type}.results.title`)}
            </Text>
            <Text>
              <Trans
                components={{ Span: <Span /> }}
                i18nKey={`recipes-overview:made-right.${type}.results.description`}
              />
            </Text>
          </FoodOption>
        </FoodBox>
      </Stack>
      <ButtonBox>
        <Link href="/meal-plan" passHref>
          <Button>{t(`recipes-overview:made-right.cta-button`)}</Button>
        </Link>
      </ButtonBox>
    </MadeRightRoot>
  )
}

MadeRight.displayName = 'MadeRight'
